import React from 'react'
import styled from 'styled-components'

const SortIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
`
const gray = 'var(--ds-gray-2)'
const blue = 'var(--primary)'

const SortIcon = ({ sortOrder }) => {
  if (sortOrder === 'descend') {
    return (
      <SortIconContainer>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
        >
          <path
            d="M3.08872 2.47786L1.23729 4.3293C0.986572 4.58001 0.581572 4.58001 0.330858 4.3293C0.0801437 4.07858 0.0801437 3.67358 0.330858 3.42287L3.27514 0.47858C3.333 0.420704 3.40372 0.36929 3.48729 0.337063C3.56443 0.304953 3.648 0.285713 3.73157 0.285713C3.81514 0.285713 3.89872 0.304953 3.97586 0.337063C4.053 0.36929 4.12372 0.420704 4.188 0.47858L7.13229 3.42287C7.383 3.67358 7.383 4.07858 7.13229 4.3293C6.88157 4.58001 6.47657 4.58001 6.22586 4.3293L4.37443 2.47786V15.0714C4.37443 15.425 4.08514 15.7143 3.73157 15.7143C3.378 15.7143 3.08872 15.425 3.08872 15.0714V2.47786Z"
            fill={blue}
          />
        </svg>
      </SortIconContainer>
    )
  }

  if (sortOrder === 'ascend') {
    return (
      <SortIconContainer>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="16"
          viewBox="0 0 8 16"
          fill="none"
        >
          <path
            d="M6.22586 11.6707L4.37443 13.5221V0.92857C4.37443 0.574999 4.08514 0.285713 3.73157 0.285713C3.378 0.285713 3.08872 0.574999 3.08872 0.92857V13.5221L1.23729 11.6707C0.986572 11.42 0.581572 11.42 0.330858 11.6707C0.0801437 11.9214 0.0801437 12.3264 0.330858 12.5771L3.27514 15.5214C3.333 15.5793 3.40372 15.6307 3.48729 15.6629C3.56443 15.695 3.648 15.7143 3.73157 15.7143C3.81514 15.7143 3.89872 15.695 3.97586 15.6629C4.053 15.6307 4.12372 15.5857 4.188 15.5214L7.13229 12.5771C7.383 12.3264 7.383 11.9214 7.13229 11.6707C6.88157 11.42 6.47657 11.42 6.22586 11.6707Z"
            fill={blue}
          />
        </svg>
      </SortIconContainer>
    )
  }

  return (
    <SortIconContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.86915 0.286133C4.22221 0.286133 4.51075 0.575139 4.51075 0.928711V13.5225L6.36036 11.6709C6.61069 11.4203 7.01435 11.4203 7.26466 11.6709C7.51501 11.9216 7.51501 12.3264 7.26466 12.5771L4.32521 15.5215C4.26101 15.5858 4.19032 15.6309 4.11329 15.6631C4.03626 15.6952 3.9526 15.7139 3.86915 15.7139C3.78574 15.7139 3.70201 15.6952 3.62501 15.6631C3.54165 15.6309 3.47082 15.5793 3.4131 15.5215L0.473643 12.5771C0.223299 12.3264 0.223309 11.9216 0.473643 11.6709C0.723992 11.4202 1.12857 11.4202 1.37892 11.6709L3.22755 13.5225V0.928711C3.22755 0.575175 3.51614 0.28619 3.86915 0.286133ZM12.1182 0.286133C12.2015 0.28617 12.2854 0.304802 12.3623 0.336914C12.4392 0.369065 12.5097 0.420734 12.5674 0.478516L15.5068 3.42285H15.5264C15.7767 3.67356 15.7767 4.07839 15.5264 4.3291C15.276 4.57982 14.8715 4.57982 14.6211 4.3291L12.7725 2.47754V15.0713C12.7725 15.4248 12.4839 15.7138 12.1309 15.7139C11.7778 15.7139 11.4893 15.4249 11.4893 15.0713V2.47754L9.63966 4.3291C9.51136 4.4511 9.35133 4.51557 9.18458 4.51562C9.01768 4.51562 8.85691 4.45767 8.72853 4.3291C8.47831 4.07839 8.47825 3.67353 8.72853 3.42285L11.669 0.478516C11.7267 0.414346 11.7971 0.369021 11.874 0.336914C11.951 0.304799 12.0348 0.286133 12.1182 0.286133Z"
          fill={gray}
        />
      </svg>
    </SortIconContainer>
  )
}

export default SortIcon
